import { render, staticRenderFns } from "./ServiceDetailsModal.vue?vue&type=template&id=543ff57c&"
import script from "./ServiceDetailsModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ServiceDetailsModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543ff57c')) {
      api.createRecord('543ff57c', component.options)
    } else {
      api.reload('543ff57c', component.options)
    }
    module.hot.accept("./ServiceDetailsModal.vue?vue&type=template&id=543ff57c&", function () {
      api.rerender('543ff57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/components/ServiceDetailsModal.vue"
export default component.exports